var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.229 0C13.7115 0 14.1026 0.415775 14.1026 0.928659V12.0855L15.4594 10.4446C15.7829 10.0534 16.3447 10.0189 16.7084 10.3679C17.0652 10.7104 17.097 11.2941 16.7796 11.678L14.013 15.0239C13.6607 15.45 13.0405 15.4631 12.6726 15.0523L9.65262 11.681C9.32092 11.3107 9.33071 10.7258 9.67458 10.3683C10.025 10.004 10.5881 10.0146 10.9261 10.392L12.3554 11.9875V0.928659C12.3554 0.415775 12.7465 0 13.229 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.8837 14.1176C1.3947 14.1176 0.998293 14.539 0.998293 15.0588C0.998293 15.5786 1.3947 16 1.8837 16H8.84912C9.33812 16 9.73453 15.5786 9.73453 15.0588C9.73453 14.539 9.33812 14.1176 8.84912 14.1176H1.8837Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.998301 10.3528C0.998301 9.83305 1.39471 9.41166 1.88371 9.41166H6.22826C6.71725 9.41166 7.11366 9.83305 7.11366 10.3528C7.11366 10.8726 6.71725 11.294 6.22826 11.294H1.8837C1.39471 11.294 0.998301 10.8726 0.998301 10.3528Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.8837 4.70569C1.3947 4.70569 0.998291 5.12708 0.998291 5.64688C0.998291 6.16668 1.3947 6.58806 1.8837 6.58806H3.60738C4.09637 6.58806 4.49278 6.16668 4.49278 5.64688C4.49278 5.12708 4.09637 4.70569 3.60738 4.70569H1.8837Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.998859 0.928363C0.998859 0.415642 1.38987 0 1.8722 0C2.35454 0 2.74555 0.415642 2.74555 0.928363V0.953404C2.74555 1.46612 2.35454 1.88177 1.8722 1.88177C1.38987 1.88177 0.998859 1.46612 0.998859 0.953404V0.928363Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortDown);
export default __webpack_public_path__ + "static/media/sort-down.4d7f5e2eb88cf4e67b1a8541034591da.svg";
export { ForwardRef as ReactComponent };